import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MonitoringService } from 'src/app/services/monitoring.service';


@Injectable({
  providedIn: 'root'
})

export class MediaService {

  monitoringService: MonitoringService;

  private imageEndpoint = environment.storageAccount.uri;

  constructor(private injector: Injector, private http: HttpClient) {
    this.monitoringService = this.injector.get(MonitoringService);
  }

  async uploadMedia(media: File) {
    console.debug(`uploading image ${media.name}....`);

    const blobName = this.sanitizeFileName(media.name);

    const headers = new HttpHeaders({
      'Content-Type': media.type
    });

    try {
      const response = await firstValueFrom(
        this.http.post<{ url: string }>(
          `${this.imageEndpoint}/${encodeURIComponent(blobName)}`,
          media,
          { headers }
        )
      );

      const url = response.url;

      console.debug(`Upload succeeded, url: ${url}`);

      this.monitoringService.logEvent("Image Upload Succeeded", {
        "ImageUrl": url
      });

      return {
        url: url
      };

    } catch (ex) {
      console.error(`Error: ${JSON.stringify(ex, null, 4)}`);
      throw ex;
    }
  }

  private sanitizeFileName(fileName: string): string {
    const lastDot = fileName.lastIndexOf('.');
    const name = lastDot > 0 ? fileName.substring(0, lastDot) : fileName;
    const extension = lastDot > 0 ? fileName.substring(lastDot).toLowerCase() : '';

    const safeName = name
      .normalize('NFKD')
      .replace(/[^a-zA-Z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .toLowerCase() || 'image';

    const safeExtension = extension.replace(/[^a-zA-Z0-9.]+/g, '');

    return `${safeName}${safeExtension}`;
  }
}
